<template>
  <Dialog :visible="visible" class="irinox-dialog-light after-sales" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '95vw', maxWidth: '800px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div>{{$t('afterSales.upload_document.select_model_title')}}</div>
    </template>

    <div class="irinox-dialog-light-content layout-content">
      <div class="subtitle p-pb-2">{{$t('afterSales.upload_document.select_model_subtitle')}}</div>
      <div class="irinox-form p-pt-2">
          <Tree
            :value="nodes"
            selectionMode="checkbox"
            :propagateSelectionUp="false"
            :propagateSelectionDown="false"
            v-model:selectionKeys="selectionKeys"
            v-model:expandedKeys="expandedKeys"
            :filter="true" filterMode="lenient"
          />
      </div>
    </div>


    <template #footer>
      <Button :label="$t('afterSales.upload_document.select_model_button')" @click="buttonClick"/>
    </template>
  </Dialog>

</template>

<script>
export default {
    components: {
    },
    emits: ['update:visible', 'update:docTreeIds'],
    props: {
      visible: Boolean,
      docTreeRaw: Array,
      docTreeIds: Array,
      domain: String,
    },
    data() {
        return {
          docTree: [],
          selectionKeys: {},
          expandedKeys: {},
        };
    },
    computed: {
      nodes() {
        return this.docTree.find(d => d.domain === this.domain)?.docTree || [];
      },
    },
    watch: {
    },
    created() {
        this.convertDocTreeRawInDocTree();
    },
    mounted() {
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.selectionKeys = {};
          this.expandedKeys = {};
        }
        this.$emit("update:visible", value);
      },
      buttonClick() {
        let selectedLeafKeys = Object.keys(this.selectionKeys || {}).filter(k => k.startsWith('LEAF|||')).map(k => parseInt(k.substring(7))).sort((a, b) => a - b);
        this.$emit("update:docTreeIds", selectedLeafKeys);
        this.updateVisible(false);
      },
      show() {
        const selectedLeafKeys = (this.docTreeIds || []).map(id => 'LEAF|||' + id);
        const { selectionKeys, expandedKeys } = this.buildSelectionAndExpanded(selectedLeafKeys);
        this.expandedKeys = expandedKeys;
        this.selectionKeys = selectionKeys;
      },
      convertDocTreeRawInDocTree() {
        this.docTree = [];

        this.docTreeRaw.forEach(item => {
          // Trova (o crea) il dominio
          let domainNode = this.docTree.find(d => d.domain === item.domain);
          if (!domainNode) {
            domainNode = { domain: item.domain, docTree: [] };
            this.docTree.push(domainNode);
          }

          let currentLevel = domainNode.docTree;

          // Itera sui livelli (level1..level5)
          for (let i = 1; i <= 5; i++) {
            const key = item[`level${i}`];
            if (!key) break;

            const label = item[`level${i}Translation`] || key; // fallback a key se manca la traduzione

            let node = currentLevel.find(n => n.key === key);
            if (!node) {
              node = { key, label, children: [] };
              currentLevel.push(node);
            } else {
              // Se il nodo esiste ma non ha label e ora c'è una traduzione, valorizzala
              if (!node.label && label) node.label = label;
            }

            // Se è l'ultimo livello disponibile in questa riga, assegna docTreeId
            if (i === 5 || !item[`level${i+1}`]) {
              node.key = 'LEAF|||' + item.docTreeId; // non sovrascrivere se già presente
            }

            currentLevel = node.children;
          }
        });
      },
      buildSelectionAndExpanded(selectedLeafKeys) {
        const selected = new Set(selectedLeafKeys);
        const selectionKeys = {};
        const expandedKeys = {};

        const visit = (node) => {

          const hasChildren = Array.isArray(node.children) && node.children.length > 0;

          if (!hasChildren) {
            const isChecked = selected.has(node.key);
            if (isChecked) {
              selectionKeys[node.key] = { checked: true, partialChecked: false };
            }
            return { checked: isChecked, partial: false, any: isChecked };
          }

          // Visita i figli
          let any = false;              // almeno un figlio selezionato (full o partial)
          let allFullyChecked = true;   // tutti i figli full (checked=true & !partial)
          for (const child of node.children) {
            const st = visit(child);
            any = any || st.any || st.checked || st.partial;
            if (!(st.checked && !st.partial)) {
              // se un figlio NON è "full", il parent non può essere "allFullyChecked"
              allFullyChecked = false;
            }
          }

          let checked = false;
          let partial = false;

          if (allFullyChecked && hasChildren) {
            checked = true;  // full
            partial = false;
          } else if (any) {
            checked = false;  // partial
            partial = true;
          }

          if (checked || partial) {
            selectionKeys[node.key] = { checked, partialChecked: partial };
            expandedKeys[node.key] = true; // espandi i rami coinvolti
          }

          return { checked, partial, any };
        };

        for (const n of this.nodes) visit(n);

        return { selectionKeys, expandedKeys };
      }
    }
}
</script>

<style>

</style>